export const hasScopedInquiryConversionData = (data) =>
  Array.isArray(data) &&
  data.length > 0 &&
  data.every(
    (item) =>
      item?.qualifiedConversionRate != null &&
      item?.allConversionRate != null &&
      item?.qualifiedInquiries != null &&
      item?.allInquiries != null
  );

export const selectInquiryConversionScope = (data, scope = 'qualified') => {
  if (!Array.isArray(data)) return [];

  const showingQualified = scope === 'qualified';

  return data.map((item) => {
    const allInquiries = Math.max(
      0,
      Number(item?.allInquiries ?? item?.inquiries ?? 0) || 0
    );
    const studentInquiries = Math.max(
      0,
      Number(item?.numberOfStudentInquiries ?? item?.allInquiries ?? item?.inquiries ?? 0) || 0
    );
    const conversionBaseInquiries = Math.max(
      0,
      Number(
        showingQualified
          ? item?.qualifiedInquiries ?? item?.eligibleInquiries ?? item?.inquiries ?? 0
          : allInquiries
      ) || 0
    );

    return {
      ...item,
      // Preserve the original student-inquiry volume; the toggle only changes conversion math.
      numberOfStudentInquiries: studentInquiries,
      conversionBaseInquiries,
      conversionRate: showingQualified
        ? item?.qualifiedConversionRate ?? '—'
        : item?.allConversionRate ?? item?.conversionRate ?? '0%',
    };
  });
};
